import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { TranslatorContext } from '@jutro/locale';
import { Flex, FlexItem, Grid } from '@jutro/layout';
import { MockUpUtil } from 'gw-portals-util-js';
import styles from '../BuildingHeaderComponent/BuildingHeaderComponent.module.scss';
import messages from './BopQuoteInfo.messages';

const PATH_TO_MOCK_DATA = 'quote.bop';

function BopQuoteInfo(props) {
    const { submissionVM } = props;
    const translator = useContext(TranslatorContext);
    const quoteId = _.get(submissionVM, 'quoteID.value');

    const isContactNameMocked = MockUpUtil.isValueMocked(
        _.get(submissionVM, 'value'),
        PATH_TO_MOCK_DATA,
        'baseData.accountHolder.contactName'
    );

    let companyName = _.get(submissionVM, 'baseData.accountHolder.contactName.value');

    if (isContactNameMocked) {
        submissionVM.value = MockUpUtil.cleanUpMockedProperties(
            _.get(submissionVM, 'value'),
            PATH_TO_MOCK_DATA,
            'baseData.accountHolder.contactName'
        );
        companyName = '';
    }

    const address = _.get(submissionVM, 'baseData.policyAddress.value');
    const { displayName } = address;

    const isAddressDisplayNameMocked = MockUpUtil.isDisplayNameMocked(
        _.get(submissionVM, 'value'),
        PATH_TO_MOCK_DATA,
        'baseData.policyAddress.displayName',
        'baseData.policyAddress.addressLine1',
        'baseData.policyAddress.city'
    );
    const policyAddressToShowInHeader = isAddressDisplayNameMocked
        ? `${address.state} ${address.postalCode}`
        : displayName;

    return (
        <Grid className={styles.infoBarContainer}>
            <Flex
                id="infoBar"
                justifyContent="evenly"
            >
                <FlexItem className={styles.infoBlock}>
                    {translator(messages.businessQuote)}
                    <div id="contextSubmissionId">
                        {quoteId}
                    </div>
                </FlexItem>
                <FlexItem className={styles.infoBlock}>
                    {translator(messages.company)}
                    <div id="contextCompanyName">
                        {companyName}
                    </div>
                </FlexItem>
                <FlexItem className={styles.infoBlock}>
                    {translator(messages.location)}
                    <div id="contextLocation">
                        {policyAddressToShowInHeader}
                    </div>
                </FlexItem>
            </Flex>
        </Grid>
    );
}

BopQuoteInfo.propTypes = {
    submissionVM: PropTypes.shape({
        value: PropTypes.shape({})
    }).isRequired
};

export default BopQuoteInfo;
